module.exports = __webpack_public_path__ + "static/img/version_icon_blue.8a20626.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/version_icon_blue.png
// module id = n2+a
// module chunks = 1